var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6285,
    cy: 13.9996,
    r: 13.4996,
    stroke: "#6C584C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_2656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9964 7.97548C21.355 8.42789 20.6449 8.77391 19.8934 9.00022C19.49 8.53642 18.9539 8.20769 18.3576 8.05849C17.7614 7.90929 17.1336 7.94682 16.5594 8.166C15.9851 8.38518 15.492 8.77545 15.1468 9.284C14.8015 9.79256 14.6208 10.3949 14.6291 11.0095V11.6793C13.4521 11.7098 12.2858 11.4487 11.2341 10.9194C10.1824 10.39 9.27791 9.60878 8.60124 8.64524C8.60124 8.64524 5.9222 14.6731 11.95 17.3521C10.5707 18.2884 8.92751 18.7579 7.26172 18.6916C13.2896 22.0404 20.6569 18.6916 20.6569 10.9894C20.6563 10.8028 20.6383 10.6167 20.6033 10.4335C21.2869 9.75938 21.7693 8.90827 21.9964 7.97548Z",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0742,
    height: 16.0742,
    fill: "white",
    transform: "translate(6.58984 5.96875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIc);
export default __webpack_public_path__ + "static/media/TWITTER_ic.ddc4732abc2df8c0783b3fce6dfb5389.svg";
export { ForwardRef as ReactComponent };